import React, { Component, PureComponent } from 'react';
import { base16Themes } from 'react-base16-styling';
import { ActionCreators, } from '@redux-devtools/core';
import { Button, Divider, SegmentedControl, Slider, Toolbar, } from '@redux-devtools/ui';
import reducer from './reducers.js';
import SliderButton from './SliderButton.js';
const { reset, jumpToAction } = ActionCreators;
class SliderMonitor extends (PureComponent ||
    Component) {
    constructor() {
        super(...arguments);
        this.state = {
            timer: undefined,
            replaySpeed: '1x',
        };
        this.setUpTheme = () => {
            let theme;
            if (typeof this.props.theme === 'string') {
                if (typeof base16Themes[this.props.theme] !== 'undefined') {
                    theme = base16Themes[this.props.theme];
                }
                else {
                    theme = base16Themes.nicinabox;
                }
            }
            else {
                theme = this.props.theme;
            }
            return theme;
        };
        this.handleReset = () => {
            this.pauseReplay();
            this.props.dispatch(reset());
        };
        this.handleKeyPress = (event) => {
            if (!this.props.keyboardEnabled) {
                return null;
            }
            if (event.ctrlKey && event.keyCode === 74) {
                // ctrl+j
                event.preventDefault();
                if (this.state.timer) {
                    return this.pauseReplay();
                }
                if (this.state.replaySpeed === 'Live') {
                    this.startRealtimeReplay();
                }
                else {
                    this.startReplay();
                }
            }
            else if (event.ctrlKey && event.keyCode === 219) {
                // ctrl+[
                event.preventDefault();
                this.stepLeft();
            }
            else if (event.ctrlKey && event.keyCode === 221) {
                // ctrl+]
                event.preventDefault();
                this.stepRight();
            }
            return null;
        };
        this.handleSliderChange = (value) => {
            if (this.state.timer) {
                this.pauseReplay();
            }
            this.props.dispatch(jumpToAction(this.props.stagedActionIds[value]));
        };
        this.startReplay = () => {
            const { computedStates, currentStateIndex, dispatch, stagedActionIds } = this.props;
            if (computedStates.length < 2) {
                return;
            }
            const speed = this.state.replaySpeed === '1x' ? 500 : 200;
            let stateIndex;
            if (currentStateIndex === computedStates.length - 1) {
                dispatch(jumpToAction(stagedActionIds[0]));
                stateIndex = 0;
            }
            else if (currentStateIndex === computedStates.length - 2) {
                dispatch(jumpToAction(stagedActionIds[currentStateIndex + 1]));
                return;
            }
            else {
                stateIndex = currentStateIndex + 1;
                dispatch(jumpToAction(stagedActionIds[currentStateIndex + 1]));
            }
            let counter = stateIndex;
            const timer = window.setInterval(() => {
                if (counter + 1 <= computedStates.length - 1) {
                    dispatch(jumpToAction(stagedActionIds[counter + 1]));
                }
                counter += 1;
                if (counter >= computedStates.length - 1) {
                    clearInterval(this.state.timer);
                    this.setState({
                        timer: undefined,
                    });
                }
            }, speed);
            this.setState({ timer });
        };
        this.startRealtimeReplay = () => {
            if (this.props.computedStates.length < 2) {
                return;
            }
            if (this.props.currentStateIndex === this.props.computedStates.length - 1) {
                this.props.dispatch(jumpToAction(this.props.stagedActionIds[0]));
                this.loop(0);
            }
            else {
                this.loop(this.props.currentStateIndex);
            }
        };
        this.loop = (index) => {
            let currentTimestamp = Date.now();
            let timestampDiff = this.getLatestTimestampDiff(index);
            const aLoop = () => {
                const replayDiff = Date.now() - currentTimestamp;
                if (replayDiff >= timestampDiff) {
                    this.props.dispatch(jumpToAction(this.props.stagedActionIds[this.props.currentStateIndex + 1]));
                    if (this.props.currentStateIndex >=
                        this.props.computedStates.length - 1) {
                        this.pauseReplay();
                        return;
                    }
                    timestampDiff = this.getLatestTimestampDiff(this.props.currentStateIndex);
                    currentTimestamp = Date.now();
                    this.setState({
                        timer: requestAnimationFrame(aLoop),
                    });
                }
                else {
                    this.setState({
                        timer: requestAnimationFrame(aLoop),
                    });
                }
            };
            if (index !== this.props.computedStates.length - 1) {
                this.setState({
                    timer: requestAnimationFrame(aLoop),
                });
            }
        };
        this.getLatestTimestampDiff = (index) => this.getTimestampOfStateIndex(index + 1) -
            this.getTimestampOfStateIndex(index);
        this.getTimestampOfStateIndex = (stateIndex) => {
            const id = this.props.stagedActionIds[stateIndex];
            return this.props.actionsById[id].timestamp;
        };
        this.pauseReplay = (cb) => {
            if (this.state.timer) {
                cancelAnimationFrame(this.state.timer);
                clearInterval(this.state.timer);
                this.setState({
                    timer: undefined,
                }, () => {
                    if (typeof cb === 'function') {
                        cb();
                    }
                });
            }
        };
        this.stepLeft = () => {
            this.pauseReplay();
            if (this.props.currentStateIndex !== 0) {
                this.props.dispatch(jumpToAction(this.props.stagedActionIds[this.props.currentStateIndex - 1]));
            }
        };
        this.stepRight = () => {
            this.pauseReplay();
            if (this.props.currentStateIndex !== this.props.computedStates.length - 1) {
                this.props.dispatch(jumpToAction(this.props.stagedActionIds[this.props.currentStateIndex + 1]));
            }
        };
        this.changeReplaySpeed = (replaySpeed) => {
            this.setState({ replaySpeed });
            if (this.state.timer) {
                this.pauseReplay(() => {
                    if (replaySpeed === 'Live') {
                        this.startRealtimeReplay();
                    }
                    else {
                        this.startReplay();
                    }
                });
            }
        };
    }
    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('keydown', this.handleKeyPress);
        }
    }
    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('keydown', this.handleKeyPress);
        }
    }
    render() {
        const { currentStateIndex, computedStates, actionsById, stagedActionIds, hideResetButton, } = this.props;
        const { replaySpeed } = this.state;
        const theme = this.setUpTheme();
        const max = computedStates.length - 1;
        const actionId = stagedActionIds[currentStateIndex];
        let actionType = actionsById[actionId].action.type;
        if (actionType === undefined)
            actionType = '<UNDEFINED>';
        else if (actionType === null)
            actionType = '<NULL>';
        else
            actionType = actionType.toString() || '<EMPTY>';
        const onPlayClick = replaySpeed === 'Live' ? this.startRealtimeReplay : this.startReplay;
        const playPause = this.state.timer ? (React.createElement(SliderButton, { theme: theme, type: "pause", onClick: this.pauseReplay })) : (React.createElement(SliderButton, { theme: theme, type: "play", disabled: max <= 0, onClick: onPlayClick }));
        return (React.createElement(Toolbar, { noBorder: true, compact: true, fullHeight: true, theme: theme },
            playPause,
            React.createElement(Slider, { label: actionType, sublabel: `(${actionId})`, min: 0, max: max, value: currentStateIndex, onChange: this.handleSliderChange, theme: theme }),
            React.createElement(SliderButton, { theme: theme, type: "stepLeft", disabled: currentStateIndex <= 0, onClick: this.stepLeft }),
            React.createElement(SliderButton, { theme: theme, type: "stepRight", disabled: currentStateIndex === max, onClick: this.stepRight }),
            React.createElement(Divider, { theme: theme }),
            React.createElement(SegmentedControl, { theme: theme, values: ['Live', '1x', '2x'], selected: replaySpeed, onClick: this.changeReplaySpeed }),
            !hideResetButton && [
                React.createElement(Divider, { key: "divider", theme: theme }),
                React.createElement(Button, { key: "reset", theme: theme, onClick: this.handleReset }, "Reset"),
            ]));
    }
}
SliderMonitor.update = reducer;
SliderMonitor.defaultProps = {
    select: (state) => state,
    theme: 'nicinabox',
    preserveScrollTop: true,
    keyboardEnabled: true,
};
export default SliderMonitor;
